import { ClickAwayListener, Popper } from "@mui/base";

import { GoToPageForm } from "./GoToPageForm";
import { GoToPageMenu } from "./GoToPageMenu";
import styles from "./PageJumpPopper.module.scss";

export interface PageJumpPopperProps {
  isOpen: boolean;
  onClose: () => void;
  onGoToPage: (page: number) => void;
  totalPages: number;
  currentPage: number;
  anchorEl: HTMLElement | null;
}

export const PageJumpPopper: React.FC<PageJumpPopperProps> = ({
  isOpen,
  onClose,
  onGoToPage,
  totalPages,
  currentPage,
  anchorEl,
}) => {
  const handleGoToPage = (page: number) => {
    onGoToPage(page);
    onClose();
  };

  return (
    <Popper
      open={isOpen}
      anchorEl={anchorEl}
      placement="top"
      style={{ zIndex: 1000 }}
    >
      <ClickAwayListener onClickAway={onClose}>
        <div className={styles.pageJumpPopper}>
          {totalPages < 10 ? (
            <GoToPageMenu
              totalPages={totalPages}
              currentPage={currentPage}
              onSubmit={handleGoToPage}
            />
          ) : (
            <GoToPageForm
              totalPages={totalPages}
              currentPage={currentPage}
              onSubmit={handleGoToPage}
              onCancel={onClose}
            />
          )}
        </div>
      </ClickAwayListener>
    </Popper>
  );
};
